import { ENTRY_DATA_SECTION_KEYS as SECTION_KEYS } from "@frontend/common";

export const ARTICLE_SECTION_CODE = {
  C000: SECTION_KEYS.clinicalTrial,
  C001: SECTION_KEYS.clinicalTrialStatus,
  C003: "Clinical Trials",
  C004: SECTION_KEYS.conferenceSchedule,
  C005: SECTION_KEYS.clinicalTrial,
  C006: SECTION_KEYS.deals,
  C007: "Clinical Trials",
  C008: SECTION_KEYS.publicationJournal,
  C009: "Clinical Trials",
  C010: "Clinical Trials",
  C011: "Clinical Trials",
  C012: "Clinical Trials",
  C013: SECTION_KEYS.regulatory,
  C014: "Clinical Trials",
  C015: "Clinical Trials",
  C016: SECTION_KEYS.expeditedProgram,
  C017: "Clinical Trials",
  C018: "Clinical Trials",
  C019: "Clinical Trials",
  C020: "Clinical Trials",
  C021: SECTION_KEYS.ventureCapital,
  C022: "Clinical Trials",
  C023: "Clinical Trials",
  C024: "Clinical Trials",
  C025: "Clinical Trials",
  C801: SECTION_KEYS.dealFiling,
  C802: SECTION_KEYS.fundingFiling,
  P001: SECTION_KEYS.publication,
  P002: SECTION_KEYS.publication,
  P004: SECTION_KEYS.publication,
  P005: SECTION_KEYS.publication,
  P006: SECTION_KEYS.publication,
  P007: SECTION_KEYS.publication,
  P008: SECTION_KEYS.publication,
  P009: SECTION_KEYS.publication,
  P010: SECTION_KEYS.publication,
  P011: SECTION_KEYS.publication,
  P012: SECTION_KEYS.publication,
  P013: SECTION_KEYS.publication,
  P014: SECTION_KEYS.publication,
  P999: SECTION_KEYS.publication,
  ctg: SECTION_KEYS.ctg,
  DERA001: SECTION_KEYS.ctg,
  DERA002: SECTION_KEYS.ctg,
  DERA003: SECTION_KEYS.ctg,
  DERA004: SECTION_KEYS.ctg,
  DERA005: SECTION_KEYS.ctg,
  DERA006: SECTION_KEYS.ctg,
  DERA007: SECTION_KEYS.ctg,
} as const;
